// client/src/utils/recipients.js
import api from './api';

export async function fetchRecipients() {
    const { data } = await api.get('/recipients');
    return data;
}

export async function fetchAdminRecipients() {
    const { data } = await api.get('/admin/recipients');
    return data;
}

export async function createRecipient(payload) {
    const { data } = await api.post('/admin/recipients', payload);
    return data;
}

export async function updateRecipient(id, payload) {
    const { data } = await api.put(`/admin/recipients/${id}`, payload);
    return data;
}

export async function setDefaultFinishedJobRecipient(id) {
    const { data } = await api.patch(`/admin/recipients/${id}/default-finished-jobs`);
    return data;
}

export async function deleteRecipient(id) {
    const { data } = await api.delete(`/admin/recipients/${id}`);
    return data;
}
